import moment from 'moment';

export function isStartDatePast(startDate: string): boolean {
	const dateFormat = 'YYYY/MM/DD';
	const startMoment = moment(startDate, dateFormat);
	const currentMoment = moment();
	return startMoment.isSameOrBefore(currentMoment, 'day');
}
